module.exports = __webpack_public_path__ + "img/discount-h5-clean.d3f5ab81.png";